<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions="6000302">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="orderOperateDetailReportBO.ajax?cmd=doQuery"
          :params="fullSearchData"
          bizName="自有记录订单导出"
          bizCode="exp100051"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
            :fixed="item.prop === 'customerCode'"
          >
            <section slot-scope="scope">
              <section v-if="scope.column.property === 'companyName'" @click="toDetail(scope.row)">
                <span class="primary cur">{{scope.row[scope.column.property]}}</span>
              </section>
              <section
                v-if="scope.column.property !== 'companyName'"
              >{{scope.row[scope.column.property]}}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  orderOperateDetailReport,
} from 'api/report';
import ExportBtn from 'components/exportBtn';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'orderNo', label: '订单号' },
          { prop: 'dependTime', label: '靠台日期' },
          { prop: 'orderCreateDate', label: '录入时间' },
          { prop: 'companyName', label: '客户全称' },
          { prop: 'customNumber', label: '客户单号' },
          { prop: 'sourceCode', label: '线路编码' },
          { prop: 'routeInfo', label: '运输线路' },
          { prop: 'routePoint', label: '经停信息' },
          { prop: 'sourceName', label: '线路名称' },
          { prop: 'plateNumber', label: '车牌号码' },
          { prop: 'trailerNumber', label: '挂车车牌' },
          { prop: 'vehicleType', label: '车型' },
          { prop: 'vehicleOwnerShipName', label: '车辆性质' },
          { prop: 'carDriverMan', label: '主驾' },
          { prop: 'carDriverManMobile', label: '主驾手机' },
          { prop: 'copilotMan', label: '副驾' },
          { prop: 'copilotManMobile', label: '副驾手机' },
          { prop: 'orgName', label: '归属部门' },
          { prop: 'localUserName', label: '跟单员' },
          { prop: 'operateName', label: '录入员' },
          { prop: 'carDependDate', label: '实际发车时间' },
          { prop: 'carStartDate', label: '实际离台时间' },
          { prop: 'carArriveDate', label: '实际到达时间' },
          { prop: 'costPrice', label: '预估收入' },
          { prop: 'incomeExceptionFee', label: '收入异常' },
          { prop: 'priceTotal', label: '收入合计' },
          { prop: 'diffFee', label: '对账调整' },
          { prop: 'confirmReviceFee', label: '确认应收' },
          { prop: 'badDebt', label: '坏账' },
          { prop: 'paymentWay', label: '成本模式' },
          { prop: 'directCost', label: '直接成本' },
          { prop: 'oliAmount', label: '油卡金额' },
          { prop: 'oliCapacity', label: '油卡升数' },
          { prop: 'fixedPointAmount', label: '定点油费' },
          { prop: 'fixedPointCapacity', label: '定点油费升数' },
          { prop: 'comsumPontage', label: 'ETC消费金额' },
          { prop: 'advanceChargeCash', label: '预付款/到付款/尾款（现金）' },
          { prop: 'insuranceFee', label: '保费' },
          { prop: 'payamt', label: '变动成本' },
          { prop: 'driverApplyTotalFee', label: '司机报销' },
          { prop: 'driverApplyOilFee', label: '司机报销-油费' },
          { prop: 'driverApplyEtcFee', label: '司机报销-路桥费' },
          { prop: 'finePrice', label: '时效罚款(司机)' },
          { prop: 'costExceptionFee', label: '成本异常' },
          { prop: 'prepaidServiceCharge', label: '预支手续费' },
          { prop: 'oliTurnBalance', label: '油转现折扣' },
          { prop: 'oliRebateVirtual', label: '加油返利' },
          { prop: 'etcTurnBalance', label: 'ETC转现折扣' },
          { prop: 'consumeProfit', label: 'ETC利润' },
          { prop: 'manageFee', label: '管理费用分摊' },
          { prop: 'netReceipts', label: '实收' },
          { prop: 'pontage', label: '订单路桥费' },
          { prop: 'grossProfit', label: '毛利' },
          { prop: 'grossMargin', label: '毛利率' },
          { prop: 'netProfit', label: '净利' },
          { prop: 'netInterestRate', label: '净利率' },
          { prop: 'startKm', label: '出货公里数' },
          { prop: 'loadingKm', label: '装货公里数' },
          { prop: 'unloadingKm', label: '卸货公里数' },
          { prop: 'endKm', label: '交车公里数' },
          { prop: 'isFullOil', label: '满油上报' },
          { prop: 'reportKm', label: '上报公里数' },
          { prop: 'mileageNumber', label: '订单公里数' },
          { prop: 'noLoadKilometers', label: '空载公里数' },
          { prop: 'oilConsumption', label: '百公里油耗' },
          { prop: 'fuelSavingLiters', label: '节油升数' },
          { prop: 'kilometreIncome', label: '单公里收入' },
          { prop: 'kilometreCost', label: '单公里主营成本' },
          { prop: 'bill', label: '票据' },
          { prop: 'orderStateName', label: '订单状态' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: orderOperateDetailReport,
    toDetail (item, type = '') {
      this.jump({
        label: type ? '审核客户' : '客户详情',
        url: `/manage/archives/customer/archives/detail?id=${item.customerId}&type=${type}`,
        full: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
